module.exports = __webpack_public_path__ + "static/img/u8.d9bc977b.png";